module.exports = __webpack_public_path__ + "img/002-life-insurance.074911b2.png";